import React, { useState, useEffect } from 'react';
import { Search, User } from 'lucide-react';
import chatService from '../../services/chatService';
import { chatStore } from '../../stores/chatStore';
import { authStore } from '../../stores/authStore';

const UsuariosOnlineList = ({ onIniciarConversa }) => {
  const [usuarios, setUsuarios] = useState([]);
  const [busca, setBusca] = useState('');
  const [carregando, setCarregando] = useState(true);
  const { user } = authStore();
  const { usuariosOnline } = chatStore();

  useEffect(() => {
    carregarUsuarios();
  }, []);

  const carregarUsuarios = async () => {
    try {
      setCarregando(true);
      const data = await chatService.buscarUsuariosDisponiveis(user.id, busca);
      setUsuarios(data);
    } catch (error) {
      console.error('Erro ao carregar usuários:', error);
    } finally {
      setCarregando(false);
    }
  };

  const usuariosFiltrados = usuarios.filter(
    (u) =>
      u.nome.toLowerCase().includes(busca.toLowerCase()) ||
      u.email.toLowerCase().includes(busca.toLowerCase())
  );

  const getIniciais = (nome) => {
    return nome
      .split(' ')
      .map((n) => n[0])
      .join('')
      .substring(0, 2)
      .toUpperCase();
  };

  if (carregando) {
    return (
      <div className="flex-1 flex items-center justify-center text-gray-400 dark:text-dark-muted">
        <p className="text-sm">Carregando usuários...</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full">
      {/* Busca */}
      <div className="p-3 border-b border-gray-200 dark:border-dark-border">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
          <input
            type="text"
            placeholder="Buscar usuários..."
            value={busca}
            onChange={(e) => setBusca(e.target.value)}
            className="w-full pl-10 pr-3 py-2 border border-gray-300 dark:border-dark-border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 dark:bg-dark-bg dark:text-dark-text"
          />
        </div>
      </div>

      {/* Lista */}
      <div className="flex-1 overflow-y-auto">
        {usuariosFiltrados.length === 0 ? (
          <div className="flex flex-col items-center justify-center h-full text-gray-400 dark:text-dark-muted p-4">
            <User className="w-12 h-12 mb-2 opacity-50" />
            <p className="text-sm text-center">Nenhum usuário encontrado</p>
          </div>
        ) : (
          usuariosFiltrados.map((usuario) => {
            const online = usuariosOnline.has(usuario.id);
            return (
              <button
                key={usuario.id}
                onClick={() => onIniciarConversa(usuario)}
                className="w-full p-3 hover:bg-gray-50 dark:hover:bg-dark-hover border-b border-gray-100 dark:border-dark-border transition-colors text-left flex items-center gap-3"
              >
                <div className="relative flex-shrink-0">
                  {usuario?.fotoPerfil ? (
                    <img
                      src={usuario.fotoPerfil}
                      alt={usuario.nome}
                      onError={(e) => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = '/default-profile.webp';
                      }}
                      className="w-10 h-10 rounded-full object-cover"
                    />
                  ) : (
                    <div className="w-10 h-10 rounded-full bg-primary-100 dark:bg-primary-900/30 flex items-center justify-center text-primary-600 dark:text-primary-400 font-semibold">
                      {getIniciais(usuario.nome)}
                    </div>
                  )}
                  <div
                    className={`absolute bottom-0 right-0 w-3 h-3 rounded-full border-2 border-white dark:border-dark-card ${
                      online ? 'bg-green-500' : 'bg-gray-400'
                    }`}
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-gray-900 dark:text-dark-text truncate">
                    {usuario.nome}
                  </div>
                  <div className="text-xs text-gray-500 dark:text-dark-muted truncate">
                    {usuario.email}
                  </div>
                </div>
              </button>
            );
          })
        )}
      </div>
    </div>
  );
};

export default UsuariosOnlineList;